/**
 * Custom hook for managing dropdowns in DrivePanel
 *
 * Extracted from DrivePanel.tsx
 */

import { useState, useRef, useCallback, useEffect } from 'react';
import type { UseDriveDropdownsProps, UseDriveDropdownsReturn } from '../types/drive-panel.types';

/**
 * Manages dropdown state for filters and periods
 */
export function useDriveDropdowns({
}: UseDriveDropdownsProps = {}): UseDriveDropdownsReturn {
  // Estado para dropdown de filtros compacto
  const [isFilterDropdownOpen, setIsFilterDropdownOpen] = useState(false);
  const filterDropdownRef = useRef<HTMLButtonElement | null>(null); // Puede venir de ChatInputArea
  const filterDropdownMenuRef = useRef<HTMLDivElement>(null);

  // Estados para otros dropdowns
  const [isPeriodDropdownOpen, setIsPeriodDropdownOpen] = useState(false);
  const periodDropdownRef = useRef<HTMLButtonElement | null>(null); // Puede venir de ChatInputArea
  const periodDropdownMenuRef = useRef<HTMLDivElement>(null);

  const toggleFilterDropdown = useCallback(() => {
    setIsFilterDropdownOpen(prev => !prev);
  }, []);

  const togglePeriodDropdown = useCallback(() => {
    setIsPeriodDropdownOpen(prev => !prev);
  }, []);

  // Cerrar dropdowns al hacer click fuera
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      // Filter dropdown
      if (
        isFilterDropdownOpen &&
        filterDropdownRef.current &&
        filterDropdownMenuRef.current &&
        !filterDropdownRef.current.contains(event.target as Node) &&
        !filterDropdownMenuRef.current.contains(event.target as Node)
      ) {
        setIsFilterDropdownOpen(false);
      }

      // Period dropdown
      if (
        isPeriodDropdownOpen &&
        periodDropdownRef.current &&
        periodDropdownMenuRef.current &&
        !periodDropdownRef.current.contains(event.target as Node) &&
        !periodDropdownMenuRef.current.contains(event.target as Node)
      ) {
        setIsPeriodDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isFilterDropdownOpen, isPeriodDropdownOpen]);

  return {
    isFilterDropdownOpen,
    isPeriodDropdownOpen,
    filterDropdownRef,
    periodDropdownRef,
    filterDropdownMenuRef,
    periodDropdownMenuRef,
    toggleFilterDropdown,
    togglePeriodDropdown,
  };
}
